import {
    getRole,
    isLoadingRole,
    selectAchievementsTimeline,
    selectAchievementsTypes,
    selectAllAchievements,
    selectCompletedAchievements,
    selectIsAchievementsTimelineLoading,
    selectIsAchievementsTypesLoading,
    selectIsAllAchievementsLoading,
    selectIsCompletedAchievementsLoading,
    selectIsLockedAchievementsLoading,
    selectIsUnlockedAchievementsLoading,
    selectLockedAchievements,
    selectUnlockedAchievements,
    userInfo,
    getSelectedPetId
} from 'core/selectors';
import {
    getAchievementsTimeline,
    getAchievementsTypes,
    getAllAchievements,
    getLockedAchievements,
    getUnlockedAchievements
} from 'core/slices/achievements';
import { getUserRoles, getUserSelectedPet, patchUserSelectedPet } from 'core/slices/users';
import { connect } from 'react-redux';
import { HallOfHonor } from '../../../components/hall/components/HallOfHonor';

export default connect(
    state => ({
        userRole: getRole(state),
        userInfo: userInfo(state),
        isLoadingRole: isLoadingRole(state),
        // Achievement data
        allAchievements: selectAllAchievements(state),
        lockedAchievements: selectLockedAchievements(state),
        unlockedAchievements: selectUnlockedAchievements(state),
        completedAchievements: selectCompletedAchievements(state),
        achievementsTypes: selectAchievementsTypes(state),
        achievementsTimeline: selectAchievementsTimeline(state),
        // Loading states
        isAllAchievementsLoading: selectIsAllAchievementsLoading(state),
        isLockedAchievementsLoading: selectIsLockedAchievementsLoading(state),
        isUnlockedAchievementsLoading: selectIsUnlockedAchievementsLoading(state),
        isCompletedAchievementsLoading: selectIsCompletedAchievementsLoading(state),
        isAchievementsTypesLoading: selectIsAchievementsTypesLoading(state),
        isAchievementsTimelineLoading: selectIsAchievementsTimelineLoading(state),
        selectedPetId: getSelectedPetId(state),
    }),
    {
        getUserRoles,
        getAllAchievements,
        getLockedAchievements,
        getUnlockedAchievements,
        getAchievementsTypes,
        getAchievementsTimeline,
        getUserSelectedPet,
        patchUserSelectedPet
    }
)(HallOfHonor); 
 